import validate from "/var/www/paribu.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import tenant_45global from "/var/www/paribu.com/middleware/tenant.global.ts";
import manifest_45route_45rule from "/var/www/paribu.com/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  tenant_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}